module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABMUlEQVRIS+1W0VECMRTcrUA70A6EDrQDS4AOrgOhArQCzwosATpQKxA70AqWWeZyw8Q4JHeAMEO+bi552bzdl80jEkNSBeABwGVqvuO/JYAx42BJAwBvHTfdFrb8BbgtonS+SaAGcOPYvQMaRNI1gM81oKR7AM871st71yTHgRFJCoAW86qUqsz1Q5LvTZYt4PpjT+OO5OJkAH+sCwBrnitBrwyfSFaSbgHMMyXoBTglOTkDRlQfL6UfAL6j09o56sYbHxNFY9O/6JLhC8lRZhW2yxqLfD0JQB/S/hdT6swDpbMEA76f8TjeoklJeL74KVZ6aRjM269FXP5/3aIY8MstRskD7MfUFzy3fdwEdGcxKgUs9YMWMAT+C+BBmqjNDO0Qbh1y24YcWt2OVHamePEKvJUpD+2B6gIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/icon-2.png
// module id = j+VO
// module chunks = 96